// The announcement text: the one thing on the page that says what a caller
// actually hears.
//
// It lives in company_messages.body — the legacy `company_messages.text` the
// importer carried over. The old booking form showed it in a row labelled
// "Ansagetext" (Box::getBasicForm), and the calendar connector is still handed
// the same string as `announcementText` (api2/calendar.php, now
// httpapi/v2). The portal was the only one of the three that had dropped it.
//
// It is never translated: whoever configured the announcement typed it in the
// language their callers hear, which is why it arrives as itself rather than
// as a key. All that happens to it here is what the legacy form did — the five
// screaming placeholders get their readable spelling back.

const substitutions: [string, string][] = [
  ["[NAME]", "[Name]"],
  ["[REPRESENTATIVEPHONE]", "[Telefonnummer Vertretung]"],
  ["[NAMEREPRESENTATIVE]", "[Name der Vertretung]"],
  ["[DATE]", "[Datum]"],
  ["[USERPHONE]", "[Telefonnummer]"],
];

/**
 * announcementText is Box::parseCompanyMessge, plus the line endings.
 *
 * The texts were typed into a Windows textarea and stored with CRLF. HTML
 * collapses both halves into one space, which is how the legacy form managed
 * to show a four-line announcement as a paragraph; the portal keeps the breaks
 * instead, so the text on screen is shaped like the text that was written.
 */
export function announcementText(raw: string | undefined): string {
  if (!raw) return "";
  let out = raw.replace(/\r\n?/g, "\n");
  for (const [from, to] of substitutions) out = out.split(from).join(to);
  return out.trim();
}
